export const FEATURE_FLAG_EXPERIMENT_COOKIE_NAME = "x-flag-exp"
export const FEATURE_FLAG_INTERNAL_COOKIE_NAME = "x-flag-internal"

export const flags = {
  FLAG_FEAT_ANNUAL_SURVEY: "membership-annual-survey-link",
  FLAG_FEAT_APPLICATIONS_MEMBERSHIP: "applications-membership",
  FLAG_FEAT_APPLICATIONS_DENIAL_MESSAGE: "applications-denial-message",
  FLAG_FEAT_CAREER_PROFILE_DASHBOARD: "pga-career-profile-dashboard",
  FLAG_FEAT_EDUCATION_CPP_PURCHASE: "education-cpp-purchase",
  FLAG_FEAT_EDUCATION_SUBSCRIPTION_RENEWAL: "education-subscription-renewal",
  FLAG_FEAT_TERMINATED_PROGRAM_STATUS: "membership-terminated-program-status",
}
